/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import {
  isAgencyEnabled,
  isUserDoctorNurseRoleGroup,
} from '@mummssoftware/utils/utils';
import { ProgressNotes as ProgressNotesWidget } from '@mummssoftware/utils/constants';
import { CPF, PRN } from '@mummssoftware/utils/orders/orders-constants';
import {
  GlobalContext,
  CLOSE_WIDGET,
} from '@mummssoftware/global-context/GlobalContext';
import {
  OrdersGlobalContext,
  OPEN_CREATE_ORDER,
  SET_ORDER_TYPE,
} from '@mummssoftware/global-context/OrdersGlobalContext';
import { MMD, ADM } from '@mummssoftware/utils/orders';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { Admit, Refer } from '../Context/constants';
import { Context } from '../../context';

type OrdersMenuProps = {
  orders: mumms.OrderType[] | null;
  saveInitialNote?: boolean;
};

const OrdersMenu = ({ orders, saveInitialNote }: OrdersMenuProps) => {
  const { currentUser, saveFirstNote } = useContext(Context);
  const { dispatch, closeTagMenu } = useContext(ProgressNotesContext);
  const { patientGlobal, dispatch: dispatchGlobal } = useContext(GlobalContext);
  const { dispatchOrders } = useContext(OrdersGlobalContext);

  // only show orders for enabled agencies
  const enabledOrderBins: string = window.env?.enabledOrderBins as string;
  const isSelectedAgency = isAgencyEnabled(enabledOrderBins, currentUser);
  const [menuOrders, setMenuOrders] = useState<mumms.OrderType[] | null>(
    orders,
  );
  const [admitReason, setAdmReason] = useState<boolean | string>(false);
  const [admitEnabled, setAdmEnabled] = useState<boolean | string>(true);

  const setMedicationMenu = () => {
    const medOrderEl =
      orders && orders.length
        ? orders.find((el) => el.shortname === MMD)
        : false;
    if (medOrderEl) {
      const isDoctorNurseUser = isUserDoctorNurseRoleGroup(currentUser);
      if (!isDoctorNurseUser) {
        const updatedMedOrderEl = { ...medOrderEl, disabled: true };
        const updatedOrders =
          orders?.map((el) =>
            el.shortname === MMD ? updatedMedOrderEl : el,
          ) || null;
        setMenuOrders(updatedOrders);
      }
    }
  };
  const setAdmitMenu = () => {
    // for ADMIT need to show the reason if this is disabled in the menu
    const hasAdmitOrderEl =
      orders && orders.length
        ? orders.find((el) => el.shortname === ADM)
        : false;

    if (patientGlobal && hasAdmitOrderEl) {
      const { patientAllowedActionList } = patientGlobal;
      if (patientAllowedActionList && patientAllowedActionList.length) {
        const admitEl = patientAllowedActionList.find(
          (el) =>
            el.patientAction === Admit ||
            el.patientAction.toLowerCase() === Refer,
        );
        const isAdmitOrderEnabled = admitEl ? admitEl.enabled : false;
        const admReason = admitEl ? admitEl.disableReason : false;
        setAdmReason(admReason);
        setAdmEnabled(isAdmitOrderEnabled);
      }
    }
  };

  useEffect(() => {
    setAdmitMenu();
    setMedicationMenu();
  }, []);

  const setChoice = (choice: mumms.OrderType) => async () => {
    if (saveInitialNote) {
      // open and click the menu, a note has been created, so keep this one
      // This is the first NOTE API Call
      await saveFirstNote(!!choice);
    }
    // submenu set the order type and close the menu
    // order type is for OrderStatement in NoteComponent
    dispatchOrders({
      type: SET_ORDER_TYPE,
      payload: choice.shortname as mumms.EntityOrderType,
    });
    closeTagMenu();
    if (choice.shortname === CPF || choice.shortname === PRN) {
      dispatchOrders({
        type: OPEN_CREATE_ORDER,
        payload: true,
      });
      dispatchGlobal({
        type: CLOSE_WIDGET,
        payload: {
          componentName: ProgressNotesWidget,
        },
      });
    }
  };

  return (
    <div>
      {menuOrders &&
        menuOrders.map((choice: mumms.OrderType, i: number) => {
          const isADMchoice = choice.shortname === ADM;
          const choiceText =
            isADMchoice && admitReason
              ? `${choice.name} - ${admitReason}`
              : `${choice.name}`;
          const choiceDisabled = isADMchoice ? !admitEnabled : choice.disabled;

          return isSelectedAgency ? (
            <MenuItem
              key={`choice-${i}`}
              onClick={setChoice(choice)}
              disabled={choiceDisabled}
            >
              {choiceText}
            </MenuItem>
          ) : (
            <MenuItem key={`choice-${i}`} disabled onClick={setChoice(choice)}>
              {choice.name}
            </MenuItem>
          );
        })}
    </div>
  );
};

export default OrdersMenu;
